<template>
  <div class="title p-max-wrap" :class="{ dark }">
    <div class="p-max-1500">
      <div class="ft-50">{{ item.title }}</div>
<!--      <div class="ff-dr ft-30">{{ item.sub }}</div>-->
      <div>
        <img :src="img" alt="">
      </div>
      <div class="line">
        <div class="cl fit"></div>
        <div class="cl middle"></div>
        <div class="cl fit"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item', 'dark'],
  computed: {
    img () {
      if (this.dark) {
        return '/images/series-dark.png'
      }
      return '/images/series.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.ft-50, .ft-30 {
  color: #fff;
}
.line {
  width: 100%;
  display: flex;

  .cl {
    height: 1px;
  }

  .middle {
    width: 44px;
  }

  .fit {
    flex: auto;
    background-color: #fff;
  }
}

.dark .ft-50 {
  color: #03192f;
}
.dark .ft-30 {
  color: #797979;
}
.dark .line .fit {
  background-color: #797979;
}

.title {
  padding-top: 60px;
  padding-bottom: 40px;
}
.p-max-1500 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ft-30 {
  margin-top: 12px;
  margin-bottom: 30px;
}

img {
  transform: translateY(10px);
}
</style>
